import { useCodePipelineQuery, useDeleteCodePipelineMutation } from './useCodePipelinesQuery';

export const useCodePipeline = (pipelineName?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = useCodePipelineQuery(pipelineName || '');
    const deleteCodePipelineMutation = useDeleteCodePipelineMutation();

    const deleteRecord = async () => {
        if (typeof pipelineName === 'undefined') {
            throw new Error('pipelineName is required parameter');
        }
        return await deleteCodePipelineMutation.mutateAsync(pipelineName);
    };

    return {
        record,
        loading,
        fetchRecord,
        deleteRecord,
    };
};
